export const HOMESTEAD_SERIES_EPISODE_1_ID = 'dee2b65a-ccaa-437b-810d-bbd36bcfd98f'
